module.exports = __webpack_public_path__ + "static/media/Logo_ParaPass_Short.9ac8fa5e.png";